import { Controller } from "@hotwired/stimulus"

// Toggles the header's mobile nav panel (hamburger button) below the `md`
// breakpoint. Keyboard/screen-reader friendly: toggles `hidden` on the panel
// and keeps `aria-expanded` on the button in sync.
export default class extends Controller {
  static targets = ["panel", "button"];

  toggle() {
    const isHidden = this.panelTarget.classList.toggle("hidden");
    this.buttonTarget.setAttribute("aria-expanded", (!isHidden).toString());
  }

  close() {
    this.panelTarget.classList.add("hidden");
    this.buttonTarget.setAttribute("aria-expanded", "false");
  }
}
